import { inject } from '@angular/core';
import { Router, CanActivateFn, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

/**
 * Guest guard - prevents authenticated users from accessing auth pages
 * Redirects logged-in users to their appropriate dashboard
 */
export const guestGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.authReady$.pipe(
        take(1),
        map((authenticated) => {
            if (!authenticated) {
                return true; // Allow access to auth pages
            }

            // Redirect authenticated users to their dashboard
            const userType = authService.currentUserType();
            return redirectAuthenticatedUser(userType, router);
        })
    );
};

function redirectAuthenticatedUser(userType: string | null, router: Router): UrlTree {
    switch (userType) {
        case 'owner':
            return router.createUrlTree(['/dashboard']);
        case 'agency':
            return router.createUrlTree(['/agency/dashboard']);
        case 'maid':
            return router.createUrlTree(['/maid/dashboard']);
        case 'employer':
            return router.createUrlTree(['/employer']);
        default:
            return router.createUrlTree(['/auth']);
    }
}
